import { useTranslation } from 'react-i18next';

import { InstitutionFieldDocument } from '@/features/institution/components/fields/document';
import type { InstitutionOwnershipOrDefaults } from '@/features/institution/ownership/schema';
import { DocumentSource } from '@/services/api/documents';

const InstitutionOwnershipFieldsetChart = () => {
  const { t } = useTranslation();

  return (
    <InstitutionFieldDocument<InstitutionOwnershipOrDefaults>
      description={t('institutionDetails.ownership.chart.description')}
      label={t('institutionDetails.ownership.chart.ownershipChart')}
      name="ownershipChart"
      source={DocumentSource.COMPANY_DOCUMENTS}
    />
  );
};
InstitutionOwnershipFieldsetChart.displayName = 'InstitutionOwnershipFieldsetChart';

export { InstitutionOwnershipFieldsetChart };
